import React from 'react'
import { useLocation } from 'react-router-dom'

function Takhfifan() {
    const path = useLocation();
    console.log("path takh", path)
  return (
    <div>Takhfifan</div>
  )
}

export default Takhfifan